<template>
    <v-flex>
    <div class="mt-3 ml-3">
				<v-flex >
					<v-btn> konfiguruj dla oferty </v-btn>
					<v-btn v-if="isContestModular" @click="$emit('changeConfig',1)"> konfiguruj osobno dla każdego modułu </v-btn>
					<v-btn v-if="isContestModular" @click="$emit('changeConfig',2)"> relacje między modułami </v-btn>
				</v-flex>
				<v-flex style="margin: 8px;">
				<v-tooltip v-if="isContestModular" bottom max-width="480px">
							<template v-slot:activator="{ on }">
								{{ informationShort }}
								<v-icon color="primary" dark v-on="on">info</v-icon>
							</template>
							<span>
								{{ information }}
							</span>
						</v-tooltip>
				</v-flex>
				<v-flex>
					<v-btn @click="fullSave" primary>Zapisz</v-btn>
				</v-flex>
			</div>
<v-card-text>
				<v-container fluid>
					<v-layout mb-3 ml-3>
						<h3>Limity dofinansowania</h3>
					</v-layout>
					<v-layout ml-3>
						<v-expand-transition>
							<v-flex xs4 v-show="!settings.fundingPerCountry">
								<egranty-number-input-field
									v-model="settings.minFunding"
									label="Minimalna kwota dofinansowania"
									for="contest-financial-settings-view-min-funding"
									id="contest-financial-settings-view-min-funding"
									suffix=" PLN"
									placeholder="np. 50000"
								></egranty-number-input-field>
								<egranty-number-input-field
									v-model="settings.maxFunding"
									label="Maksymalna kwota dofinansowania"
									for="contest-financial-settings-view-max-funding"
									id="contest-financial-settings-view-max-funding"
									suffix=" PLN"
									placeholder="np. 5000000"
								></egranty-number-input-field>
							</v-flex>
						</v-expand-transition>
					</v-layout>

					<v-layout>
						<egranty-switch
							:disabled="contestData.announced"
							v-model="settings.fundingPerCountry"
							aria-label="funding per country enabled"
							title="Limity dofinansowania inne na każdy kraj"
							@input="perCountrySwitchHandler"
						></egranty-switch>
					</v-layout>
					<v-layout>
						<v-expand-transition>
							<v-flex v-if="settings.fundingPerCountry">
								<egranty-switch
									aria-label="funding per legal form per country enabled"
									:disabled="contestData.announced"
									v-model="settings.fundingPerLegalFormPerCountry"
									title="Dodatkowo inne na każdą formę prawną"
								></egranty-switch>

								<v-expand-transition>
									<v-layout v-if="!settings.fundingPerLegalFormPerCountry">
										<v-flex>
											<financial-limits-per-country
												ref="financialLimitsPerCountry"
												@error="openFinancialLimitErrorPopup"
											></financial-limits-per-country>
										</v-flex>
									</v-layout>
								</v-expand-transition>

								<v-expand-transition>
									<v-layout v-if="settings.fundingPerLegalFormPerCountry">
										<v-flex>
											<financial-limits-per-legal-form
												ref="financialLimitsPerLegalForm"
												:legal-forms="legalForms"
												@error="openFinancialLimitErrorPopup"
											></financial-limits-per-legal-form>
										</v-flex>
									</v-layout>
								</v-expand-transition>
							</v-flex>
						</v-expand-transition>
					</v-layout>


					<v-flex my-4>
						<v-divider/>
					</v-flex>
					<v-layout ma-3>
						<v-flex>
							<h3>Minimalny poziom wkładu własnego</h3>
						</v-flex>
					</v-layout>
					<v-layout row>

						<v-flex xs4 ml-3>
							<v-subheader> {{ settings.minOwnContributionRefersToWholeCosts === true ?
								"Wartość wkładu odnosi się do całkowitego kosztu realizacji zadania" :
								"Wartość wkładu odnosi się do wnioskowanej dotacji" }}
							</v-subheader>
						</v-flex>
						<v-flex xs12 sm3>
							<v-btn flat icon color="green" @click="changeMinContributionReferral()">
								<v-icon>cached</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<egranty-switch
						:disabled="contestData.announced"
						v-model="settings.minOwnContributionPerLegalForm"
						aria-label="minimum own contribution per legal form enabled"
						title="Inna wartość dla każdej formy prawnej"
						@input="minOwnContributionPerLegalFormHandler"
					></egranty-switch>

					<v-expand-transition>
						<v-layout v-show="settings.minOwnContributionPerLegalForm" class="ml-3">
							<v-flex xs6>
								<v-data-table
									:items="legalForms"
									:headers="tableHeaders"
									class="elevation-1"
									hide-actions>
									<template slot="items" slot-scope="props">
										<td>{{ props.item.legalForm.name }}</td>
										<td>{{ formatMoney(props.item.minOwnContributionSize) }}</td>
										<td>
											<v-icon
												small
												class="mr-2"
												@click="editLegalFormMinOwnContributionSize(props.item)">
												edit
											</v-icon>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-expand-transition>
						<v-layout v-show="!settings.minOwnContributionPerLegalForm" class="ml-3">
							<v-flex xs1>
								<egranty-number-input-field
									v-model="settings.minOwnContributionSize"
									suffix="%"
									placeholder="np. 25"
								></egranty-number-input-field>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-flex my-4>
						<v-divider/>
					</v-flex>
					<v-layout ma-3>
						<v-flex>
							<h3>Maksymalny poziom wkładu własnego</h3>
						</v-flex>
					</v-layout>
					<v-layout row>

						<v-flex xs4 ml-3>
							<v-subheader> {{ settings.maxOwnContributionRefersToWholeCosts === true ?
								"Wartość wkładu odnosi się do całkowitego kosztu realizacji zadania" :
								"Wartość wkładu odnosi się do wnioskowanej dotacji" }}
							</v-subheader>
						</v-flex>
						<v-flex xs12 sm3>
							<v-btn flat icon color="green" @click="changeMaxContributionReferral()">
								<v-icon>cached</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<egranty-switch
						:disabled="contestData.announced"
						v-model="settings.maxOwnContributionPerLegalForm"
						aria-label="maximum own contribution per legal form enabled"
						title="Inna wartość dla każdej formy prawnej"
						@input="maxOwnContributionPerLegalFormHandler"
					></egranty-switch>

					<v-expand-transition>
						<v-layout v-show="settings.maxOwnContributionPerLegalForm" class="ml-3">
							<v-flex xs6>
								<v-data-table
									:items="legalForms"
									:headers="tableHeaders"
									class="elevation-1"
									hide-actions>
									<template slot="items" slot-scope="props">
										<td>{{ props.item.legalForm.name }}</td>
										<td>{{ formatMoney(props.item.maxOwnContributionSize) }}</td>
										<td>
											<v-icon
												small
												class="mr-2"
												@click="editLegalFormMaxOwnContributionSize(props.item)">
												edit
											</v-icon>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-expand-transition>
						<v-layout v-show="!settings.maxOwnContributionPerLegalForm" class="ml-3">
							<v-flex xs1>
								<egranty-number-input-field
									v-model="settings.maxOwnContributionSize"
									suffix="%"
									placeholder="np. 25"
								></egranty-number-input-field>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-layout my-3>
						<v-divider></v-divider>
					</v-layout>

					<v-layout ma-3>
						<v-flex>
							<h3>Dopuszczalna wysokość kosztów administracyjnych</h3>
						</v-flex>
					</v-layout>

					<v-layout row>
						<v-flex xs4 ml-3>
							<v-subheader> {{ settings.administrativeExpensesReferToWholeCosts ===
								true ?
									"Wysokość kosztów odnosi się do całkowitego kosztu realizacji zadania" :
									"Wysokość kosztów odnosi się do wnioskowanej dotacji" }}
							</v-subheader>
						</v-flex>
						<v-flex xs12 sm3>
							<v-btn flat icon color="green" @click="changeAdministrativeExpensesReferral()">
								<v-icon>cached</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<egranty-switch
						:disabled="contestData.announced"
						v-model="settings.administrativeExpensesPerLegalForm"
						aria-label="administrative expenses per legal form enabled"
						title="Inna wysokość dla każdej formy prawnej"
						@input="administrativeExpensesHandler"
					></egranty-switch>

					<v-expand-transition>
						<v-layout v-show="settings.administrativeExpensesPerLegalForm" class="ml-3">
							<v-flex xs6>
								<v-data-table
									:items="legalForms"
									:headers="secondTableHeaders"
									class="elevation-1"
									hide-actions>
									<template slot="items" slot-scope="props">
										<td>{{ props.item.legalForm.name }}</td>
										<td>{{ formatMoney(props.item.administrativeExpensesSize) }}</td>
										<td>
											<v-icon
												small
												class="mr-2"
												@click="editLegalFormAdministrativeExpensesSize(props.item)">
												edit
											</v-icon>
										</td>
									</template>
								</v-data-table>
							</v-flex>
						</v-layout>
					</v-expand-transition>

					<v-expand-transition>
						<v-layout v-show="!settings.administrativeExpensesPerLegalForm" class="ml-3">
							<v-flex xs1>
								<egranty-number-input-field
									v-model="settings.administrativeExpensesSize"
									suffix="%"
									placeholder="np. 50"
								></egranty-number-input-field>
							</v-flex>
						</v-layout>
					</v-expand-transition>

				</v-container>


				<egranty-input-field-popup
					:default-value="editedItem.minOwnContributionSize"
					:is-open.sync="editLegalFormMinOwnContributionSizeDialog"
					:title="'Edytuj wartość wkładu'"
					:label="'Wartość wkładu (%)'"
					field-type="NUMBER"
					suffix="%"
					placeholder="np. 50"
					@save="minOwnContributionSizeChanged"
				></egranty-input-field-popup>

				<egranty-input-field-popup
					:default-value="editedItem.maxOwnContributionSize"
					:is-open.sync="editLegalFormMaxOwnContributionSizeDialog"
					:title="'Edytuj wartość wkładu'"
					:label="'Wartość wkładu (%)'"
					field-type="NUMBER"
					suffix="%"
					placeholder="np. 50"
					@save="maxOwnContributionSizeChanged"
				></egranty-input-field-popup>

				<egranty-input-field-popup
					:default-value="editedItem.administrativeExpensesSize"
					:is-open.sync="editLegalFormAdministrativeExpensesSizeDialog"
					:title="'Edytuj wysokość kosztów'"
					:label="'Wysokość kosztów (%)'"
					field-type="NUMBER"
					suffix="%"
					placeholder="np. 50"
					@save="administrativeExpensesSizeChanged"
				></egranty-input-field-popup>

				<egranty-error-list-popup
					title="Nie udało się zapisać zmian:"
					:error-list="financialLimitError.messages"
					:is-open="financialLimitError.showPopup"
					@close="closeFinancialLimitErrorPopup"
				/>

			</v-card-text>
        </v-flex>
</template>


<script>
	import FinancialLimitsPerCountry from "../components/FinancialLimitsPerCountry";
	import egrantySwitch from "../../../../genericComponents/EgrantySwitch";
	import egrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";
	import {FinancialSettings} from "@/api/generated/FinancialSettings";
	import {PublicContest} from "@/api/generated/PublicContest";
	import egrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";
	import FinancialLimitsPerLegalForm from "../components/FinancialLimitsPerLegalForm";
	import EgrantyErrorListPopup from "../../../../genericComponents/EgrantyErrorListPopup";
	import {Numbers} from "@/utils/Numbers";

	export default {
		name: "ContestFinancialSettingsConfig",
		components: {
			EgrantyErrorListPopup,
			FinancialLimitsPerCountry,
			FinancialLimitsPerLegalForm,
			egrantySwitch,
			egrantyNumberInputField,
			egrantyInputFieldPopup,
		},
		mixins: [Numbers],

		beforeMount() {
			this.update();
		},

		mounted() {
			PublicContest.getContestLegalForms(this, this.$route.params.id, response => {
				this.legalForms = response;
				this.removeEmptyTableLoading();
			});
		},

		props: {
			information: {type: String, default:""},
			informationShort: {type: String, default:""},
		},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
					announced: undefined,
				},

				settings: {
					minFunding: null,
					maxFunding: null,
					fundingPerCountry: false,
					fundingPerLegalFormPerCountry: false,
					minOwnContributionSize: null,
					maxOwnContributionSize: null,
					minOwnContributionRefersToWholeCosts: false,
					maxOwnContributionRefersToWholeCosts: false,
					minOwnContributionPerLegalForm: false,
					maxOwnContributionPerLegalForm: false,
					administrativeExpensesSize: null,
					administrativeExpensesReferToWholeCosts: false,
					administrativeExpensesPerLegalForm: false,
				},
				legalForms: [],

				tableHeaders: [
					{text: "Forma prawna", sortable: false},
					{text: "Wartość wkładu (%)", sortable: false},
					{text: "Akcje", sortable: false},
				],
				secondTableHeaders: [
					{text: "Forma prawna", sortable: false},
					{text: "Wysokość kosztów (%)", sortable: false},
					{text: "Akcje", sortable: false},
				],

				financialLimitError: {
					showPopup: false,
					messages: [],
				},

				editedItem: {},

				editLegalFormMinOwnContributionSizeDialog: false,

				editLegalFormMaxOwnContributionSizeDialog: false,

				editLegalFormAdministrativeExpensesSizeDialog: false,

                isContestModular: false,

				// information: "Limity finansowe zostają określone jednokrotnie dla całej oferty i są takie same w każdym module. W przypadku przełączania na konfigurację modułową stanowią wartość domyślną dla modułów, w których limity finansowe nie zostały określone."

			};
		},
		methods: {
			perCountrySwitchHandler(val) {
                if (val == false){
					this.settings.fundingPerLegalFormPerCountry = false;
				}
            },
			changeMinContributionReferral() {
				this.settings.minOwnContributionRefersToWholeCosts =
					!this.settings.minOwnContributionRefersToWholeCosts;
			},

			changeMaxContributionReferral() {
				this.settings.maxOwnContributionRefersToWholeCosts =
					!this.settings.maxOwnContributionRefersToWholeCosts;
			},

			changeAdministrativeExpensesReferral() {
				this.settings.administrativeExpensesReferToWholeCosts =
					!this.settings.administrativeExpensesReferToWholeCosts;
			},

			editLegalFormMinOwnContributionSize(item) {
				this.editedItem = item;
				this.editLegalFormMinOwnContributionSizeDialog = true;
			},

			editLegalFormMaxOwnContributionSize(item) {
				this.editedItem = item;
				this.editLegalFormMaxOwnContributionSizeDialog = true;
			},

			minOwnContributionSizeChanged(value) {
				value = parseFloat(value);
				if (isNaN(value) || value < 0) {
					return;
				}
				this.editedItem.minOwnContributionSize = Math.round(value * 100) / 100;
				// this.updateDataTable(this.editedItem);
				this.editedItem = {};
				this.editLegalFormMinOwnContributionSizeDialog = false;
			},

			maxOwnContributionSizeChanged(value) {
				value = value.replace(",", ".");
				value = parseFloat(value);
				if (isNaN(value) || value < 0) {
					return;
				}
				this.editedItem.maxOwnContributionSize = Math.round(value * 100) / 100;
				// this.updateDataTable(this.editedItem);
				this.editedItem = {};
				this.editLegalFormMaxOwnContributionSizeDialog = false;
			},

			editLegalFormAdministrativeExpensesSize(item) {
				this.editedItem = item;
				this.editLegalFormAdministrativeExpensesSizeDialog = true;
			},

			administrativeExpensesSizeChanged(value) {
				value = value.replace(",", ".");
				value = parseFloat(value);
				if (isNaN(value) || value < 0) {
					return;
				}
				this.editedItem.administrativeExpensesSize = Math.round(value * 100) / 100;
				// this.updateDataTable(this.editedItem);
				this.editedItem = {};
				this.editLegalFormAdministrativeExpensesSizeDialog = false;
			},

			// updateDataTable(item) {
				// item.contestId = this.contestData.id;
			// },

			minOwnContributionPerLegalFormHandler() {
				this.settings.minOwnContributionSize = null;
			},

			maxOwnContributionPerLegalFormHandler() {
				this.settings.maxOwnContributionSize = null;
			},

			administrativeExpensesHandler() {
				this.settings.administrativeExpensesSize = null;
			},
			refreshLegalFormsValues(){
				PublicContest.getContestLegalForms(this, this.$route.params.id, response => {
				this.legalForms = response;
				this.removeEmptyTableLoading();
				});
			},

			fullSave() {
        if (this.settings.minFunding === null) {
          this.settings.minFunding = 0;
        }
        if (this.settings.maxFunding === "" || this.settings.maxFunding === null) {
          this.settings.maxFunding = null;
        }

		if(this.settings.fundingPerCountry){
			this.settings.minFunding = 0;
			this.settings.maxFunding = null;
		}
        if (this.invalidFundingValues()) {
        //   this.openFinancialLimitErrorPopup();
        } else {
				let fullFinancesObject = {};
				// ustawienia główne
				fullFinancesObject.financialSettingsDTO = this.settings;
				// fundusze na kraj lub na formy prawne w kraju(wartości z 1 switcha, gdy jest kliknięty)
				if (this.settings.fundingPerCountry && !this.settings.fundingPerLegalFormPerCountry) {
					if (this.$refs.financialLimitsPerCountry.validate()) {
						fullFinancesObject.singleFinancialLimitDTOList = this.$refs.financialLimitsPerCountry.getValuesToSave();
					} else {
						return;
					}
				} else if (this.settings.fundingPerCountry && this.settings.fundingPerLegalFormPerCountry) {
					fullFinancesObject.singleFinancialLimitDTOList = this.$refs.financialLimitsPerLegalForm.getValuesToSave();
					if (this.$refs.financialLimitsPerLegalForm.validate()) {
						fullFinancesObject.singleFinancialLimitDTOList = this.$refs.financialLimitsPerLegalForm.getValuesToSave();
					} else {
						return;
					}
				}
				// ustawienia dla form legalnych(wartości z pozostałych switchy, gdy są kliknięte)
				fullFinancesObject.updateContestLegalFormsDTOList = this.legalForms;
				FinancialSettings.postFinancialLimits(this, this.$route.params.id, fullFinancesObject, successResponse => {
					this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane", successResponse);
					this.refreshLegalFormsValues();
					this.$emit('loadInfo');
				},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zapisać zmian", errorResponse);
					});
			}
			},

			invalidFundingValues() {
				let invalid = false;
				let messages = [];
				if(!this.settings.fundingPerCountry){
					if(this.settings.maxFunding == null || this.settings.maxFunding == 0){
						messages.push("Maksymalna kwota dofinansowania nie może być równa 0.");
						invalid = true;
					}
					if(this.settings.maxFunding !== null && (parseFloat(this.settings.minFunding) > parseFloat(this.settings.maxFunding))){
						messages.push("Minimalna kwota dofinansowania nie może być większa od maksymalnej.");
						invalid = true;
					}
					if(this.settings.minFunding === ""){
						messages.push("Minimalna kwota dofinansowania musi być uzupełniona.");
						invalid = true;
					}
					if((parseFloat(this.settings.minFunding) == parseFloat(this.settings.maxFunding))){
						messages.push("Minimalna i maksymalna kwota dofinansowania nie mogą być równe.");
						invalid = true;
					}
				} 
				if(!this.settings.minOwnContributionPerLegalForm && (this.settings.minOwnContributionSize === "")){
					messages.push("Minimalny poziom wkładu własnego powinien być określony");
					invalid = true;
				}
				if(!this.settings.maxOwnContributionPerLegalForm && (this.settings.maxOwnContributionSize === "")){
						messages.push("Maksymalny poziom wkładu własnego powinien być określony");
					invalid = true;
				} if(!this.settings.administrativeExpensesPerLegalForm && (this.settings.administrativeExpensesSize === "")){
					messages.push("Dopuszczalna wysokość kosztów administracyjnych powinna być określona");
					invalid = true;
				}
				let minMaxMessage = "Minimalny poziom wkładu własnego powinien być mniejszy od maksymalnego poziomu wkładu własnego";
				if(!this.settings.minOwnContributionPerLegalForm && !this.settings.maxOwnContributionPerLegalForm){
					if(parseFloat(this.settings.maxOwnContributionSize) < parseFloat(this.settings.minOwnContributionSize)){
						if(!messages.includes(minMaxMessage)){
							messages.push("Minimalny poziom wkładu własnego powinien być mniejszy od maksymalnego poziomu wkładu własnego");
						}
							invalid = true;
						}
				}
				if(this.settings.minOwnContributionPerLegalForm && !this.settings.maxOwnContributionPerLegalForm){
					this.legalForms.forEach(x=>{
						if(parseFloat(this.settings.maxOwnContributionSize) < parseFloat(x.minOwnContributionSize)){
							if(!messages.includes(minMaxMessage)){
							messages.push("Minimalny poziom wkładu własnego powinien być mniejszy od maksymalnego poziomu wkładu własnego");
						}
							invalid = true;
						}
					});
				}
				if(this.settings.maxOwnContributionPerLegalForm){
					this.legalForms.forEach(x=>{
						if(x.maxOwnContributionSize === null){
							messages.push("Maksymalny poziom wkładu własnego powinien być określony dla formy prawnej: " + x.legalForm.name);
							invalid = true;
						}
						else if(this.settings.minOwnContributionPerLegalForm && (parseFloat(x.maxOwnContributionSize) < parseFloat(x.minOwnContributionSize))){
							if(!messages.includes(minMaxMessage)){
							messages.push("Minimalny poziom wkładu własnego powinien być mniejszy od maksymalnego poziomu wkładu własnego");
						}
							invalid = true;
						}
						else if(!this.settings.minOwnContributionPerLegalForm && (parseFloat(x.maxOwnContributionSize) < this.settings.minOwnContributionSize)){
							if(!messages.includes(minMaxMessage)){
							messages.push("Minimalny poziom wkładu własnego powinien być mniejszy od maksymalnego poziomu wkładu własnego");
						}
							invalid = true;
						}
					});
				}
				if(this.settings.administrativeExpensesPerLegalForm){
					this.legalForms.forEach(x=>{
						if(x.administrativeExpensesSize === null){
							messages.push("Dopuszczalna wysokość kosztów administracyjnych powinna być określona dla formy prawnej: " + x.legalForm.name);
							invalid = true;
						}
					});
				}
				if(invalid){
					this.openFinancialLimitErrorPopup(messages);
				}
				return invalid;
			},

			removeEmptyTableLoading() {
				var el = document.querySelector(".v-datatable__progress");
				el.parentNode.removeChild(el);
			},

			openFinancialLimitErrorPopup(errorsMessages) {
				this.financialLimitError.messages = [];
				errorsMessages.forEach(error => {
					this.financialLimitError.messages.push(error);
				});
				this.financialLimitError.showPopup = true;
				this.$messagesBus.$emit("error", "Nie udało się zapisać zmian");
			},

			closeFinancialLimitErrorPopup() {
				this.financialLimitError.showPopup = false;
			},

			update() {
				FinancialSettings.get(this, this.$route.params.id, response => {
					this.settings = response.financialSettings;
					if (this.settings.minFunding === -1) {
						this.settings.minFunding = 0;
					}
					if (this.settings.maxFunding === -1) {
						this.settings.maxFunding = null;
					}
					if(this.settings.minOwnContributionSize === null){
						this.settings.minOwnContributionSize = 0;
					}
					if(this.settings.maxOwnContributionSize === null){
						this.settings.maxOwnContributionSize = 0;
					}
					if(this.settings.administrativeExpensesSize === null){
						this.settings.administrativeExpensesSize = 0;
					}
				});
                PublicContest.getGeneralSettings(this, this.$route.params.id, response => {
				if (response.modularOfferSettings && response.modularOfferSettings.modularOffersEnabled == true) {
					this.isContestModular = true;
				}
			});
			},
		},
	};
</script>

<style scoped>

</style>